module.exports = __webpack_public_path__ + "static/thumbtack-b125541faa3af7c4be298474f67f5648.png";